import request from '@/utils/request'


// 查询用户足迹列表
export function listUserFootprint(query) {
  return request({
    url: '/user/user/footprint/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询用户足迹分页
export function pageUserFootprint(query) {
  return request({
    url: '/user/user/footprint/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询用户足迹详细
export function getUserFootprint(data) {
  return request({
    url: '/user/user/footprint/detail',
    method: 'get',
    params: data
  })
}

// 新增用户足迹
export function addUserFootprint(data) {
  return request({
    url: '/user/user/footprint/add',
    method: 'post',
    data: data
  })
}

// 修改用户足迹
export function updateUserFootprint(data) {
  return request({
    url: '/user/user/footprint/edit',
    method: 'post',
    data: data
  })
}

// 删除用户足迹
export function delUserFootprint(data) {
  return request({
    url: '/user/user/footprint/delete',
    method: 'post',
    data: data
  })
}
